// Smart Sash Admin Panel - Report Store
import { HoodUsageQueryParams, HoodUsageSession, PaginationMetadata } from '@/models';
import { reportService } from '@/services/api/reportService';
import { getErrorMessage } from '@/utils/getErrorMessage';
import { create } from 'zustand';
import { devtools } from 'zustand/middleware';

interface ReportState {
  sessions: HoodUsageSession[];
  pagination: PaginationMetadata | null;
  isLoading: boolean;
  error: string | null;
  fetchSessions: (params: HoodUsageQueryParams) => Promise<void>;
  clearError: () => void;
}

export const useReportStore = create<ReportState>()(
  devtools(
    (set) => ({
      sessions: [],
      pagination: null,
      isLoading: false,
      error: null,

      fetchSessions: async (params: HoodUsageQueryParams) => {
        set({ isLoading: true, error: null });
        try {
          const response = await reportService.getHoodUsageSessions(params);
          set({
            sessions: response.data,
            pagination: response.pagination,
            isLoading: false,
          });
        } catch (error: unknown) {
          set({
            error: getErrorMessage(error, 'Failed to fetch hood usage data'),
            isLoading: false,
          });
          throw error;
        }
      },

      clearError: () => set({ error: null }),
    }),
    { name: 'ReportStore' }
  )
);
